export default "__VITE_ASSET__sOGcd9U4__"